import { ISymbolMap } from "./ISymbolMap";

class SymbolMap {
    symbolsConfig: ISymbolMap;

    public init(symbolsConfig: ISymbolMap) {
        this.symbolsConfig = symbolsConfig;
    }

    // getSymbolByIndex(index: number) : string {
    //     return this.symbolsConfig[index];
    // }

    public setSymbolIdMask(symbol: string, mask: number) {
        this.symbolsConfig[symbol].mask = mask;
    }

    public removeSymbolMask(symbol: string) {
        this.symbolsConfig[symbol].mask = undefined;
    }

    public getSymbolId(symbol: string | number): number {
        if (symbol == undefined) {
            debugger;
        }

        if (this.symbolsConfig[symbol]) {
            return (
                this.symbolsConfig[symbol].mask || this.symbolsConfig[symbol].id
            );
        }

        if (typeof symbol === "number") {
            return parseInt(symbol.toString());
        } else {
            throw new Error("Not a valid symbol id: " + symbol);
        }
    }

    public parseSymbols(
        data: string[] | string[][] | number[] | number[][]
    ): any {
        const result = [];
        for (let i = 0; i < data.length; i++) {
            const currentData = data[i];
            if (Array.isArray(currentData)) {
                result.push(this.parseSymbols(currentData));
            } else {
                result.push(this.getSymbolId(currentData));
            }
        }
        return result;
    }
}

export default new SymbolMap();
